export default {
    DM_PLANS: ['ACHIEVER_PLAN', 'ACHIEVER_PLUS_PLAN', 'PLACEMENT_PLAN', 'CUSTOM_PLAN'],
    CURRENCY: ['INR', 'USD', 'CAD'],
    PAYMENT_METHODS: ['RAZORPAY', 'CASH', 'UPI', 'OTHER']
}